// extracted by mini-css-extract-plugin
export var lg = "_35-4";
export var md = "_35-3";
export var sm = "_35-2";
export var xs = "_35-1";
export var xxs = "_35-0";